import {useAuthStore} from '../../../stores/AuthStore/useAuthStore'
import {Pinia} from 'pinia'

export function beforeLinkPageEnterRouterHookFactory(pinia: Pinia) {
  return async function beforeLinkPageEnterRouterHook(to) {
    const authStore = useAuthStore(pinia)
    
    await authStore.initializeAuth()
    
    authStore.$patch({
      currentLinkId: to.params.linkId,
    })
  }
}
